import { computed, inject, Injectable } from '@angular/core';
import { selectPlanIsAtleastBasic } from '@app/reducers/account/account-subscription.selector';
import { getPermissionState } from '@app/reducers/auth/permission.helper';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { featureFlag, FeatureService } from '@sb/shared/feature';

@Injectable({ providedIn: 'root' })
export class ChatOptInNudgeService {
  #store = inject<Store<AppState>>(Store);
  #featureService = inject(FeatureService);

  #permissionState = this.#store.selectSignal(getPermissionState);
  #planIsAtleastBasic = this.#store.selectSignal(selectPlanIsAtleastBasic);

  showOptInNudge = computed(() => {
    // Free-plan accounts can't opt into chat at all (the controller blocks on
    // plan), so the nudge would be misleading — hide it before any other check.
    if (!this.#planIsAtleastBasic()) return false;
    if (!this.#featureService.isEnabled(featureFlag.TMP_STREAM_CHAT)) return false;
    if (!this.#featureService.isEnabled(featureFlag.TMP_CHAT_MODULE_OPT_IN_ELIGIBILITY)) return false;
    if (this.#featureService.isEnabled(featureFlag.TMP_CHAT_MODULE_OPT_IN)) return false;
    // Exclude HR Pro customers — they either already have chat or explicitly opted out.
    if (this.#featureService.isEnabled(featureFlag.TMP_CONTRACT_TEMPLATE)) return false;
    return this.#permissionState().isAccountManager ?? false;
  });
}
